import styled from "styled-components";

export const CreateSystemMessageWrapper = styled.div`
  .accordion-header {
    margin-top: 24px;
  }
`;
